/**
 * Which muscle each outline in bodyPolygons.ts draws; the head and the knees
 * draw none. Each shoulder cap is split: front delts inside and side delts
 * outside on the front view, rear delts inside and side delts outside on the
 * back. The trapezius shows on both views. Plain data, so the website can draw
 * the figure without the app's screens.
 */
import type { MuscleId } from '../science/muscles'

export const FRONT_SLUG: Readonly<Record<string, MuscleId>> = {
  chest: 'chest',
  obliques: 'abs',
  abs: 'abs',
  biceps: 'biceps',
  triceps: 'triceps',
  neck: 'neck',
  trapezius: 'upper_back',
  front_deltoids: 'front_delts',
  side_deltoids: 'side_delts',
  abductors: 'adductors',
  quadriceps: 'quads',
  calves: 'calves',
  forearm: 'forearms',
}

export const BACK_SLUG: Readonly<Record<string, MuscleId>> = {
  trapezius: 'upper_back',
  back_deltoids: 'rear_delts',
  side_deltoids: 'side_delts',
  upper_back: 'lats',
  triceps: 'triceps',
  lower_back: 'lower_back',
  obliques: 'abs',
  forearm: 'forearms',
  gluteal: 'glutes',
  abductor: 'adductors',
  hamstring: 'hamstrings',
  calves: 'calves',
  soleus: 'calves',
}
